export const CREATE_CCPA_REQUEST = "CREATE_CCPA_REQUEST"
export const CREATE_CCPA_REQUEST_SUCCESS = "CREATE_CCPA_REQUEST_SUCCESS"
export const CREATE_CCPA_REQUEST_ERROR = "CREATE_CCPA_REQUEST_ERROR"

export const SHOW_TOAST_ALERT = "SHOW_TOAST_ALERT"
export const RESET_TOAST_MESSAGE = "RESET_TOAST_MESSAGE"
